// extracted by mini-css-extract-plugin
module.exports = {"m-infoBox":"InfoBox_m-infoBox__3afzn","m-infoBox--active":"InfoBox_m-infoBox--active__2dK7Q","m-infoBox--full-width":"InfoBox_m-infoBox--full-width__36mNn"};